import { Spin } from 'antd';

export const ContainerLoader = () => {
  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        opacity: 0.7,
        background: '#ffffff',
        zIndex: 100,
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '100%',
        }}
      >
        <Spin size="large" spinning={true} />
      </div>
    </div>
  );
};
